import React from "react";
import styles from "./SendPasswordForm.scss";
import cx from "../utils/cx";
import TextField from './MaterialUi/TextField';
import getUid from '../utils/getUid';
import RequestManager from "../utils/RequestManager";
import Error from "./Error";
import Button from "./MaterialUi/Button";

export interface ISendPasswordFormProps {
  className?: string;
  name: string;
  setName: (name: string) => void;
}

const SendPasswordForm: React.FC<React.PropsWithChildren<ISendPasswordFormProps>> = ({ className = '', name, setName }) => {
    const [labelUid] = React.useState(() => getUid('formId'));
    const [isLoading, setIsLoading] = React.useState(false);
    const [wasGenerated, setWasGenerated] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleSubmit = (ev: React.FormEvent) => {
        ev.preventDefault();

        RequestManager.postRequest('/user/lost-password?_format=json', {}, { mail: name }).then((response) => {
            setIsLoading(false);
            setWasGenerated(true);
        }).catch((e) => {
            console.error(e);
            setError("Fehler beim Senden des Links. Bitte versuche es später noch einmal.");
            setIsLoading(false);
        });
    }


    return <div className={cx(styles.sendPasswordForm, className)}>
        {error && <Error className="error">{error}</Error>}
        {wasGenerated ? (<p>
            Wir haben dir einen Link zum Zurücksetzen deines Passworts an deine Mailadresse geschickt.
        </p>) : <>
            <p>
                Gib die Mailadresse an, mit der du bei wohnglueck.de registriert bist.
                Wir senden dir einen Link zu, mit dem du dein Passwort zurücksetzen kannst.
            </p>

            <form onSubmit={handleSubmit}>
                <TextField
                    label="E-Mail-Adresse"
                    type="text"
                    id={`${labelUid}Name`}
                    name="name"
                    value={name}
                    inputProps={{ maxLength: 254 }}
                    required={true}
                    aria-required="true"
                    onChange={(ev) => {
                        setName(ev?.target?.value);
                    }}
                />
                <Button onClick={handleSubmit} loading={isLoading}>
                    Reset-Link zusenden
                </Button>
            </form>
        </>}
    </div >
};

export default SendPasswordForm;
